


















import ECharts from 'vue-echarts'
import {Component} from "vue-property-decorator"
import AbpBase from "@/lib/abpbase"
import {GetDisinfectStatistics, GetPatientAgeStatistics, GetPatientOutStatistics} from "@/api/report"

@Component({
	components: {ECharts}
})
export default class Age extends AbpBase {
	loading = false
	year = new Date()
	echartsData: any = {
		tooltip: {
			trigger: 'axis'
		},
		// 数据标题
		legend: {
			data:[]
		},
		grid: {
			left: '3%',
			right: '4%',
			bottom: '3%',
			containLabel: true
		},
		toolbox: {
			feature: {
				saveAsImage: {}
			}
		},
		xAxis: {
			type: 'category',
			boundaryGap: false,
			data: [] // X轴坐标点
		},
		yAxis: {
			type: 'value'
		},
		series: [
			// {
			// 	name:'邮件营销',
			// 	type:'line',
			// 	stack: '总量',
			// 	data:[120, 132, 101, 134, 90, 230, 210]
			// },
		]
	}
	query = {
		IsTemp: -1,
	}
	data: any = []
	columns = [
		{
			title: "类别",
			key: 'type'
		},
		{
			title: "血透",
			key: 'dlyCount'
		},
		{
			title: "腹透",
			key: 'ftCount'
		},
		{
			title: "死亡",
			key: 'dieCount'
		},
		{
			title: "放弃",
			key: 'abandonCount'
		},
		{
			title: "移植",
			key: 'transplantCount'
		},
		{
			title: "其他",
			key: 'otherCount'
		},
		{
			title: "总计",
			key: 'total'
		},

	]
	created() {
		this.getData()
	}

	private async getData() {
		this.loading = true
		let query:any = {
			Year: this.year.getFullYear()
		}
		switch(this.query.IsTemp) {
			case -1:
				break
			case 1:
				query['IsTemp'] = true
				break
			case 0:
				query['IsTemp'] = false
				break
		}
		let res = await GetPatientOutStatistics(query)

		this.data = res.objects
		let legendData:any = ['血透','腹透','死亡','放弃','移植','其他']
		let xAxis:any = []
		let series:any = [
			{
				name:'血透',
				type:'line',
				stack: '总量',
				data:[]
			},{
				name:'腹透',
				type:'line',
				stack: '总量',
				data:[]
			},{
				name:'死亡',
				type:'line',
				stack: '总量',
				data:[]
			},{
				name:'放弃',
				type:'line',
				stack: '总量',
				data:[]
			},{
				name:'移植',
				type:'line',
				stack: '总量',
				data:[]
			},{
				name:'其他',
				type:'line',
				stack: '总量',
				data:[]
			},
		]

		this.data.forEach((item:any)=>{
			xAxis.push(item.type)
			series[0].data.push(item.dlyCount)
			series[1].data.push(item.ftCount)
			series[2].data.push(item.dieCount)
			series[3].data.push(item.abandonCount)
			series[4].data.push(item.transplantCount)
			series[5].data.push(item.otherCount)
		})
		this.echartsData.legend.data = legendData
		this.echartsData.xAxis.data = xAxis
		this.echartsData.series = series
		this.loading = false
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/report/patientOut/home.vue